<form #changePasswordForm="ngForm" class="form-container">
  <div class="form-header">
    <div class="form-breadcrumb">
      <h3>Change Password</h3>
    </div>
    <div class="form-actions">
      <button type="submit" mat-flat-button color="primary" (click)="save(changePasswordForm.valid)">
        <mat-icon>save</mat-icon> Save
      </button>
    </div>
  </div>
  <div class="form-card">
    <div class="row">
      <div class="col-sm-4 mb-3">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Current Password</mat-label>
          <input matInput type="password" name="currentPassword" [(ngModel)]="changePassword.currentPassword" required>
        </mat-form-field>
      </div>
      <div class="col-sm-4 mb-3">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>New Password</mat-label>
          <input matInput type="password" name="newPassword" [(ngModel)]="changePassword.newPassword" required>
        </mat-form-field>
      </div>
      <div class="col-sm-4 mb-3">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Confirm Password</mat-label>
          <input matInput type="password" name="confirmPassword" [(ngModel)]="changePassword.confirmPassword" required>
        </mat-form-field>
      </div>
    </div>
  </div>
</form>
